<template>
  <div class='report-item report-item--footer'>
    <footer>
      <div class="copy">
        <p>This report is powered by <a target='_blank' href='https://www.cogniclick.com'>CogniClick.com</a></p>
      </div>
      <div class="logo">
        <a target='_blank' href='https://www.cogniclick.com'><img src='~/images/cogniclick-grey.svg'/></a>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  props: {
    config: {default: ()=>{{}}, type: Object},
    report: {default: ()=>{{}}, type: Object},
    response: {default: ()=>{{}}, type: Object}
  }
}
</script>
<style lang='scss' scoped>
  .report-item--footer {
    background-color: white !important;
  }
  footer {
    width: 85%;
    margin: auto;
    display: flex;
    padding: 2rem 0;
    justify-content: center;
    align-items: center;
    .copy {
      flex: 0 1 70%
      a:link {
        color: #fbd147;
      }
    }
    .logo {
      flex: 0 1 30%;
      text-align: right;
      img {
        max-width: 150px;
      }
    }
  }
</style>